import React, { Component } from 'react'
import {connect} from 'react-redux'
import {assignAuthPerson, submit as saveNominated} from './actions'
import View from './views'
import Done from './views/done'

export class AuthPersonnel extends Component {

  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  render() {
    const {
      personnel, 
      authorised_id, 
      assignAuthPerson, 
      submitted, 
      loading
    } = this.props

    return (
      submitted ?
        <Done person={personnel.filter(person => (person.id === authorised_id))[0]} /> :
        <View 
          personnel={personnel} 
          authorised_id={authorised_id}
          onClick={assignAuthPerson}
          loading={loading}
          onSubmit={this.handleSubmit}
        />
    )
  }

  handleSubmit(authorised_id) {
    const {
      gov_care_registration_id,
      saveNominated,
      tokens
    } = this.props

    saveNominated({
      tokens,
      payload: {
        id: authorised_id,
        attributes: {
          gov_care_registration_id
        }
      }
    })
  }
}

const mapStateToProps = (state) => ({
  personnel: state.auth_personnel.attributes,
  loading: state.auth_personnel.loading,
  submitted: state.auth_personnel.submitted,
  authorised_id: state.auth_personnel.authorised_id,
  gov_care_registration_id: state.gov_care_registration.attributes.id,
  tokens: {
    jwt: state.authorisation.jwt
  }
})

const mapDispatchToProps = (dispatch) => ({
  assignAuthPerson: (id) => {
    dispatch(assignAuthPerson(id))
  },
  saveNominated: (params) => {
    dispatch(saveNominated(params))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(AuthPersonnel)


// WEBPACK FOOTER //
// ./src/auth-personnel/container.jsx